<ion-content>
  <div class="page-content">
    <div class="unknown-observation-icon"></div>
    <div class="title-block">
      <div class="title">{{ "DASHPAGES.UNKNOWN_title" | translate }}</div>
      <div class="description">{{ "DASHPAGES.UNKNOWN_description" | translate }} {{id}}.</div>
    </div>
  </div>
</ion-content>